<template>
    <div class="gifts-inner">
        <div class="gifts-title">给主播送礼物</div>
        <img src="../../../../assets/image/live/close.png" class="close" @click="hide"/>
        <div class="gift-box">
            <div class="gift-item" @click="sendgift">
                <img src="../../../../assets/image/live/gift-item.png" class="gift-item-img" />
                <div class="gift-text">100积分</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: {},
  data () {
    return {}
  },
  methods: {
    hide () {
      this.$emit('hideGift')
    },
    sendgift () {
      this.$emit('sendgift')
    }
  },
  computed: {}
}
</script>
<style lang="scss" scoped>
    .gifts-inner {
        padding: 0 0.50625rem;
        position: absolute;
        width: 100%;
        box-sizing: border-box;
    }
    .gifts-title {
        height: 2.4046875rem;
        line-height: 2.4046875rem;
        font-family: PingFangSC-Medium;
        font-size:$h2;
        color: #111111;
        letter-spacing: 0;
        text-align: left;
        display: block;
        border-bottom: 1px solid #DBDBDB;
    }
    .close {
        height: 1.35rem;
        width: 1.35rem;
        position: absolute;
        right: 0.50625rem;
        top: 0.50625rem;
    }
    .gift-item {
        width: 4.5984375rem;
        height: 4.5984375rem;
        float: left;
        background: rgba(0, 0, 0, 0.10);
        border-radius: 0.16875rem;
        border-radius: 0.16875rem;
        text-align: center;
        margin-bottom: 1rem;
        margin-right: .5rem;
    }
    .gift-text{font-size:$fontSize;margin-top: .5rem}
    .gift-box{
        overflow: hidden;
        padding: 0.50625rem;
    }
    .gift-item-img{
        width: 1.771875rem;
        height: 3.60703125rem;
        margin-top: 0.50625rem
    }
</style>
